var AnnouncementsQueryKeys={global:['announcements']};export{AnnouncementsQueryKeys};